import { render, staticRenderFns } from "./ButtonRightPanel.vue?vue&type=template&id=52bccd9e"
import script from "./ButtonRightPanel.vue?vue&type=script&lang=js"
export * from "./ButtonRightPanel.vue?vue&type=script&lang=js"
import style0 from "./ButtonRightPanel.vue?vue&type=style&index=0&id=52bccd9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports